module.exports = "<div class=\"modal-footer clear\"> <a class=\"btn btn-icon btn-default\" ng-click=cancel()> <i class=\"fa fa-eraser\"></i> {{ 'jdro_common.reply' | translate }} </a> <button type=submit class=\"btn btn-icon btn-primary\" ng-click=\"submitted = true\"> <i class=\"fa fa-paper-plane-o\"></i> {{ 'jdro_common.save' | translate }} </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/formButtonNoPerms.html
// module id = 383
// module chunks = 0